/**
 * R2IT Golf Scoring API
 * This swagger document describes the available API endpoints.
 *
 * OpenAPI spec version: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *//* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional }                      from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams,
         HttpResponse, HttpEvent }                           from '@angular/common/http';
import { CustomHttpUrlEncodingCodec }                        from '../encoder';

import { Observable }                                        from 'rxjs';

import { MicrosoftAspNetCoreMvcProblemDetails } from '../model/microsoftAspNetCoreMvcProblemDetails';
import { ModulesGroupsEndpointsContractsBlocksCreateBlockRequestModel } from '../model/modulesGroupsEndpointsContractsBlocksCreateBlockRequestModel';
import { ModulesTournamentsApplicationPlayerScoringProfileGetPlayerScoringProfileResponse } from '../model/modulesTournamentsApplicationPlayerScoringProfileGetPlayerScoringProfileResponse';
import { ModulesTournamentsApplicationRoundTournamentCoursesGetRoundTournamentCourseRoundTournamentCourseResponse } from '../model/modulesTournamentsApplicationRoundTournamentCoursesGetRoundTournamentCourseRoundTournamentCourseResponse';
import { ModulesTournamentsApplicationRoundsCloseRoundCloseRoundResponse } from '../model/modulesTournamentsApplicationRoundsCloseRoundCloseRoundResponse';
import { ModulesTournamentsApplicationRoundsGetUnofficialScorecardsGetUnofficialScorecardsResponse } from '../model/modulesTournamentsApplicationRoundsGetUnofficialScorecardsGetUnofficialScorecardsResponse';
import { ModulesTournamentsApplicationRoundsRoundResponse } from '../model/modulesTournamentsApplicationRoundsRoundResponse';
import { ModulesTournamentsApplicationTournamentClassificationsTournamentClassificationResponse } from '../model/modulesTournamentsApplicationTournamentClassificationsTournamentClassificationResponse';
import { ModulesTournamentsApplicationTournamentCourseStatsGetTournamentCourseStatsResponse } from '../model/modulesTournamentsApplicationTournamentCourseStatsGetTournamentCourseStatsResponse';
import { ModulesTournamentsApplicationTournamentCoursesTournamentCourseResponse } from '../model/modulesTournamentsApplicationTournamentCoursesTournamentCourseResponse';
import { ModulesTournamentsApplicationTournamentPlayerCategoriesTournamentPlayerCategoryResponse } from '../model/modulesTournamentsApplicationTournamentPlayerCategoriesTournamentPlayerCategoryResponse';
import { ModulesTournamentsApplicationTournamentPlayerTypesTournamentPlayerTypeResponse } from '../model/modulesTournamentsApplicationTournamentPlayerTypesTournamentPlayerTypeResponse';
import { ModulesTournamentsApplicationTournamentPlayersTournamentPlayerResponse } from '../model/modulesTournamentsApplicationTournamentPlayersTournamentPlayerResponse';
import { ModulesTournamentsApplicationTournamentScoringTypesTournamentScoringTypeResponse } from '../model/modulesTournamentsApplicationTournamentScoringTypesTournamentScoringTypeResponse';
import { ModulesTournamentsApplicationTournamentTeamPlayersTournamentTeamPlayerResponse } from '../model/modulesTournamentsApplicationTournamentTeamPlayersTournamentTeamPlayerResponse';
import { ModulesTournamentsApplicationTournamentTeamsTournamentTeamResponse } from '../model/modulesTournamentsApplicationTournamentTeamsTournamentTeamResponse';
import { ModulesTournamentsApplicationTournamentsCloseTournamentCloseTournamentResponse } from '../model/modulesTournamentsApplicationTournamentsCloseTournamentCloseTournamentResponse';
import { ModulesTournamentsApplicationTournamentsTournamentResponse } from '../model/modulesTournamentsApplicationTournamentsTournamentResponse';
import { ModulesTournamentsEndpointsContractsRoundsCreateRoundRequestModel } from '../model/modulesTournamentsEndpointsContractsRoundsCreateRoundRequestModel';
import { ModulesTournamentsEndpointsContractsRoundsUpdateRoundRequestModel } from '../model/modulesTournamentsEndpointsContractsRoundsUpdateRoundRequestModel';
import { ModulesTournamentsEndpointsContractsTournamentPlayersAssignPlayerBracketsRequestModel } from '../model/modulesTournamentsEndpointsContractsTournamentPlayersAssignPlayerBracketsRequestModel';
import { ModulesTournamentsEndpointsContractsTournamentPlayersCreateTournamentPlayerRequestModel } from '../model/modulesTournamentsEndpointsContractsTournamentPlayersCreateTournamentPlayerRequestModel';
import { ModulesTournamentsEndpointsContractsTournamentPlayersMovePlayerToAlternatesRequestModel } from '../model/modulesTournamentsEndpointsContractsTournamentPlayersMovePlayerToAlternatesRequestModel';
import { ModulesTournamentsEndpointsContractsTournamentPlayersSwapPlayerWithAlternateRequestModel } from '../model/modulesTournamentsEndpointsContractsTournamentPlayersSwapPlayerWithAlternateRequestModel';
import { ModulesTournamentsEndpointsContractsTournamentPlayersUpdateTournamentPlayerRequestModel } from '../model/modulesTournamentsEndpointsContractsTournamentPlayersUpdateTournamentPlayerRequestModel';
import { ModulesTournamentsEndpointsContractsTournamentTeamPlayersTournamentTeamPlayerRequest } from '../model/modulesTournamentsEndpointsContractsTournamentTeamPlayersTournamentTeamPlayerRequest';
import { ModulesTournamentsEndpointsContractsTournamentsCreateTournamentRequest } from '../model/modulesTournamentsEndpointsContractsTournamentsCreateTournamentRequest';
import { ModulesTournamentsEndpointsContractsTournamentsUpdateTournamentRequestModel } from '../model/modulesTournamentsEndpointsContractsTournamentsUpdateTournamentRequestModel';

import { BASE_PATH, COLLECTION_FORMATS }                     from '../variables';
import { Configuration }                                     from '../configuration';
import { TournamentsServiceInterface }                            from './tournaments.serviceInterface';


@Injectable()
export class TournamentsService implements TournamentsServiceInterface {

    protected basePath = '/';
    public defaultHeaders = new HttpHeaders();
    public configuration = new Configuration();

    constructor(protected httpClient: HttpClient, @Optional()@Inject(BASE_PATH) basePath: string, @Optional() configuration: Configuration) {
        if (basePath) {
            this.basePath = basePath;
        }
        if (configuration) {
            this.configuration = configuration;
            this.basePath = basePath || configuration.basePath || this.basePath;
        }
    }

    /**
     * @param consumes string[] mime-types
     * @return true: consumes contains 'multipart/form-data', false: otherwise
     */
    private canConsumeForm(consumes: string[]): boolean {
        const form = 'multipart/form-data';
        for (const consume of consumes) {
            if (form === consume) {
                return true;
            }
        }
        return false;
    }


    /**
     * Gets a player&#x27;s scoring profile for a tournament.
     * Gets per-hole scoring details, round aggregates, and tournament-level stats for a specific player.
     * @param tournamentId 
     * @param playerId 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getPlayerScoringProfileEndpoint(tournamentId: string, playerId: string, observe?: 'body', reportProgress?: boolean): Observable<ModulesTournamentsApplicationPlayerScoringProfileGetPlayerScoringProfileResponse>;
    public getPlayerScoringProfileEndpoint(tournamentId: string, playerId: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<ModulesTournamentsApplicationPlayerScoringProfileGetPlayerScoringProfileResponse>>;
    public getPlayerScoringProfileEndpoint(tournamentId: string, playerId: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<ModulesTournamentsApplicationPlayerScoringProfileGetPlayerScoringProfileResponse>>;
    public getPlayerScoringProfileEndpoint(tournamentId: string, playerId: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (tournamentId === null || tournamentId === undefined) {
            throw new Error('Required parameter tournamentId was null or undefined when calling getPlayerScoringProfileEndpoint.');
        }

        if (playerId === null || playerId === undefined) {
            throw new Error('Required parameter playerId was null or undefined when calling getPlayerScoringProfileEndpoint.');
        }

        let headers = this.defaultHeaders;

        // authentication (Keycloak) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<ModulesTournamentsApplicationPlayerScoringProfileGetPlayerScoringProfileResponse>('get',`${this.basePath}/tournaments/${encodeURIComponent(String(tournamentId))}/players/${encodeURIComponent(String(playerId))}/scoring-profile`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Gets a Round.
     * Gets a Round using the Tournament and Round identifiers.
     * @param tournamentId 
     * @param roundId 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getRoundByIdEndpoint(tournamentId: string, roundId: string, observe?: 'body', reportProgress?: boolean): Observable<ModulesTournamentsApplicationRoundsRoundResponse>;
    public getRoundByIdEndpoint(tournamentId: string, roundId: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<ModulesTournamentsApplicationRoundsRoundResponse>>;
    public getRoundByIdEndpoint(tournamentId: string, roundId: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<ModulesTournamentsApplicationRoundsRoundResponse>>;
    public getRoundByIdEndpoint(tournamentId: string, roundId: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (tournamentId === null || tournamentId === undefined) {
            throw new Error('Required parameter tournamentId was null or undefined when calling getRoundByIdEndpoint.');
        }

        if (roundId === null || roundId === undefined) {
            throw new Error('Required parameter roundId was null or undefined when calling getRoundByIdEndpoint.');
        }

        let headers = this.defaultHeaders;

        // authentication (Keycloak) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<ModulesTournamentsApplicationRoundsRoundResponse>('get',`${this.basePath}/tournaments/${encodeURIComponent(String(tournamentId))}/rounds/${encodeURIComponent(String(roundId))}`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Gets a RoundTournamentCourse.
     * Gets a RoundTournamentCourse using the Tournament, Course and Round identifiers.
     * @param tournamentId 
     * @param courseId 
     * @param roundId 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getRoundTournamentCourseEndpoint(tournamentId: string, courseId: string, roundId: string, observe?: 'body', reportProgress?: boolean): Observable<ModulesTournamentsApplicationRoundTournamentCoursesGetRoundTournamentCourseRoundTournamentCourseResponse>;
    public getRoundTournamentCourseEndpoint(tournamentId: string, courseId: string, roundId: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<ModulesTournamentsApplicationRoundTournamentCoursesGetRoundTournamentCourseRoundTournamentCourseResponse>>;
    public getRoundTournamentCourseEndpoint(tournamentId: string, courseId: string, roundId: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<ModulesTournamentsApplicationRoundTournamentCoursesGetRoundTournamentCourseRoundTournamentCourseResponse>>;
    public getRoundTournamentCourseEndpoint(tournamentId: string, courseId: string, roundId: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (tournamentId === null || tournamentId === undefined) {
            throw new Error('Required parameter tournamentId was null or undefined when calling getRoundTournamentCourseEndpoint.');
        }

        if (courseId === null || courseId === undefined) {
            throw new Error('Required parameter courseId was null or undefined when calling getRoundTournamentCourseEndpoint.');
        }

        if (roundId === null || roundId === undefined) {
            throw new Error('Required parameter roundId was null or undefined when calling getRoundTournamentCourseEndpoint.');
        }

        let headers = this.defaultHeaders;

        // authentication (Keycloak) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<ModulesTournamentsApplicationRoundTournamentCoursesGetRoundTournamentCourseRoundTournamentCourseResponse>('get',`${this.basePath}/tournaments/${encodeURIComponent(String(tournamentId))}/courses/${encodeURIComponent(String(courseId))}/rounds/${encodeURIComponent(String(roundId))}`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Gets all Tournament Rounds.
     * Gets all Rounds for a Tournament using the Tournament identifier.
     * @param tournamentId 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getRoundsByTournamentIdEndpoint(tournamentId: string, observe?: 'body', reportProgress?: boolean): Observable<Array<ModulesTournamentsApplicationRoundsRoundResponse>>;
    public getRoundsByTournamentIdEndpoint(tournamentId: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<ModulesTournamentsApplicationRoundsRoundResponse>>>;
    public getRoundsByTournamentIdEndpoint(tournamentId: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<ModulesTournamentsApplicationRoundsRoundResponse>>>;
    public getRoundsByTournamentIdEndpoint(tournamentId: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (tournamentId === null || tournamentId === undefined) {
            throw new Error('Required parameter tournamentId was null or undefined when calling getRoundsByTournamentIdEndpoint.');
        }

        let headers = this.defaultHeaders;

        // authentication (Keycloak) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<Array<ModulesTournamentsApplicationRoundsRoundResponse>>('get',`${this.basePath}/tournaments/${encodeURIComponent(String(tournamentId))}/rounds`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Gets a Tournament.
     * Gets a Tournament using the Tournament identifier.
     * @param tournamentId 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getTournamentByIdEndpoint(tournamentId: string, observe?: 'body', reportProgress?: boolean): Observable<ModulesTournamentsApplicationTournamentsTournamentResponse>;
    public getTournamentByIdEndpoint(tournamentId: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<ModulesTournamentsApplicationTournamentsTournamentResponse>>;
    public getTournamentByIdEndpoint(tournamentId: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<ModulesTournamentsApplicationTournamentsTournamentResponse>>;
    public getTournamentByIdEndpoint(tournamentId: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (tournamentId === null || tournamentId === undefined) {
            throw new Error('Required parameter tournamentId was null or undefined when calling getTournamentByIdEndpoint.');
        }

        let headers = this.defaultHeaders;

        // authentication (Keycloak) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<ModulesTournamentsApplicationTournamentsTournamentResponse>('get',`${this.basePath}/tournaments/${encodeURIComponent(String(tournamentId))}`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Gets all TournamentClassificationsByTournamentId.
     * Gets all TournamentClassificationsByTournamentId
     * @param tournamentId 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getTournamentClassificationsByTournamentIdEndpoint(tournamentId: string, observe?: 'body', reportProgress?: boolean): Observable<Array<ModulesTournamentsApplicationTournamentClassificationsTournamentClassificationResponse>>;
    public getTournamentClassificationsByTournamentIdEndpoint(tournamentId: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<ModulesTournamentsApplicationTournamentClassificationsTournamentClassificationResponse>>>;
    public getTournamentClassificationsByTournamentIdEndpoint(tournamentId: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<ModulesTournamentsApplicationTournamentClassificationsTournamentClassificationResponse>>>;
    public getTournamentClassificationsByTournamentIdEndpoint(tournamentId: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (tournamentId === null || tournamentId === undefined) {
            throw new Error('Required parameter tournamentId was null or undefined when calling getTournamentClassificationsByTournamentIdEndpoint.');
        }

        let headers = this.defaultHeaders;

        // authentication (Keycloak) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<Array<ModulesTournamentsApplicationTournamentClassificationsTournamentClassificationResponse>>('get',`${this.basePath}/tournaments/${encodeURIComponent(String(tournamentId))}/classifications`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Gets all TournamentClassifications.
     * Gets all TournamentClassifications
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getTournamentClassificationsEndpoint(observe?: 'body', reportProgress?: boolean): Observable<Array<ModulesTournamentsApplicationTournamentClassificationsTournamentClassificationResponse>>;
    public getTournamentClassificationsEndpoint(observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<ModulesTournamentsApplicationTournamentClassificationsTournamentClassificationResponse>>>;
    public getTournamentClassificationsEndpoint(observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<ModulesTournamentsApplicationTournamentClassificationsTournamentClassificationResponse>>>;
    public getTournamentClassificationsEndpoint(observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        let headers = this.defaultHeaders;

        // authentication (Keycloak) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<Array<ModulesTournamentsApplicationTournamentClassificationsTournamentClassificationResponse>>('get',`${this.basePath}/tournaments/classifications`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Gets a TournamentCourse.
     * Gets a TournamentCourse using the Tournament and Course identifiers.
     * @param tournamentId 
     * @param courseId 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getTournamentCourseEndpoint(tournamentId: string, courseId: string, observe?: 'body', reportProgress?: boolean): Observable<ModulesTournamentsApplicationTournamentCoursesTournamentCourseResponse>;
    public getTournamentCourseEndpoint(tournamentId: string, courseId: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<ModulesTournamentsApplicationTournamentCoursesTournamentCourseResponse>>;
    public getTournamentCourseEndpoint(tournamentId: string, courseId: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<ModulesTournamentsApplicationTournamentCoursesTournamentCourseResponse>>;
    public getTournamentCourseEndpoint(tournamentId: string, courseId: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (tournamentId === null || tournamentId === undefined) {
            throw new Error('Required parameter tournamentId was null or undefined when calling getTournamentCourseEndpoint.');
        }

        if (courseId === null || courseId === undefined) {
            throw new Error('Required parameter courseId was null or undefined when calling getTournamentCourseEndpoint.');
        }

        let headers = this.defaultHeaders;

        // authentication (Keycloak) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<ModulesTournamentsApplicationTournamentCoursesTournamentCourseResponse>('get',`${this.basePath}/tournaments/${encodeURIComponent(String(tournamentId))}/courses/${encodeURIComponent(String(courseId))}`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Gets tournament course stats.
     * Gets per-hole and aggregate tournament course stats for an active or selected round.
     * @param tournamentId 
     * @param courseId 
     * @param roundId 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getTournamentCourseStatsEndpoint(tournamentId: string, courseId: string, roundId?: string, observe?: 'body', reportProgress?: boolean): Observable<ModulesTournamentsApplicationTournamentCourseStatsGetTournamentCourseStatsResponse>;
    public getTournamentCourseStatsEndpoint(tournamentId: string, courseId: string, roundId?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<ModulesTournamentsApplicationTournamentCourseStatsGetTournamentCourseStatsResponse>>;
    public getTournamentCourseStatsEndpoint(tournamentId: string, courseId: string, roundId?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<ModulesTournamentsApplicationTournamentCourseStatsGetTournamentCourseStatsResponse>>;
    public getTournamentCourseStatsEndpoint(tournamentId: string, courseId: string, roundId?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (tournamentId === null || tournamentId === undefined) {
            throw new Error('Required parameter tournamentId was null or undefined when calling getTournamentCourseStatsEndpoint.');
        }

        if (courseId === null || courseId === undefined) {
            throw new Error('Required parameter courseId was null or undefined when calling getTournamentCourseStatsEndpoint.');
        }


        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (roundId !== undefined && roundId !== null) {
            queryParameters = queryParameters.set('roundId', <any>roundId);
        }

        let headers = this.defaultHeaders;

        // authentication (Keycloak) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<ModulesTournamentsApplicationTournamentCourseStatsGetTournamentCourseStatsResponse>('get',`${this.basePath}/tournaments/${encodeURIComponent(String(tournamentId))}/courses/${encodeURIComponent(String(courseId))}/stats`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Gets TournamentCourses by TournamentId.
     * Gets TournamentCourses by TournamentId.
     * @param tournamentId 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getTournamentCoursesByTournamentIdEndpoint(tournamentId: string, observe?: 'body', reportProgress?: boolean): Observable<Array<ModulesTournamentsApplicationTournamentCoursesTournamentCourseResponse>>;
    public getTournamentCoursesByTournamentIdEndpoint(tournamentId: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<ModulesTournamentsApplicationTournamentCoursesTournamentCourseResponse>>>;
    public getTournamentCoursesByTournamentIdEndpoint(tournamentId: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<ModulesTournamentsApplicationTournamentCoursesTournamentCourseResponse>>>;
    public getTournamentCoursesByTournamentIdEndpoint(tournamentId: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (tournamentId === null || tournamentId === undefined) {
            throw new Error('Required parameter tournamentId was null or undefined when calling getTournamentCoursesByTournamentIdEndpoint.');
        }

        let headers = this.defaultHeaders;

        // authentication (Keycloak) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<Array<ModulesTournamentsApplicationTournamentCoursesTournamentCourseResponse>>('get',`${this.basePath}/tournaments/${encodeURIComponent(String(tournamentId))}/courses`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Gets TournamentPlayerCategories.
     * Gets all TournamentPlayerCategories available in the system.
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getTournamentPlayerCategoriesEndpoint(observe?: 'body', reportProgress?: boolean): Observable<Array<ModulesTournamentsApplicationTournamentPlayerCategoriesTournamentPlayerCategoryResponse>>;
    public getTournamentPlayerCategoriesEndpoint(observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<ModulesTournamentsApplicationTournamentPlayerCategoriesTournamentPlayerCategoryResponse>>>;
    public getTournamentPlayerCategoriesEndpoint(observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<ModulesTournamentsApplicationTournamentPlayerCategoriesTournamentPlayerCategoryResponse>>>;
    public getTournamentPlayerCategoriesEndpoint(observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        let headers = this.defaultHeaders;

        // authentication (Keycloak) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<Array<ModulesTournamentsApplicationTournamentPlayerCategoriesTournamentPlayerCategoryResponse>>('get',`${this.basePath}/tournaments/playerCategories`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Gets a TournamentPlayer.
     * Gets a TournamentPlayer using the Tournament and Player identifiers.
     * @param tournamentId 
     * @param playerId 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getTournamentPlayerEndpoint(tournamentId: string, playerId: string, observe?: 'body', reportProgress?: boolean): Observable<ModulesTournamentsApplicationTournamentPlayersTournamentPlayerResponse>;
    public getTournamentPlayerEndpoint(tournamentId: string, playerId: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<ModulesTournamentsApplicationTournamentPlayersTournamentPlayerResponse>>;
    public getTournamentPlayerEndpoint(tournamentId: string, playerId: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<ModulesTournamentsApplicationTournamentPlayersTournamentPlayerResponse>>;
    public getTournamentPlayerEndpoint(tournamentId: string, playerId: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (tournamentId === null || tournamentId === undefined) {
            throw new Error('Required parameter tournamentId was null or undefined when calling getTournamentPlayerEndpoint.');
        }

        if (playerId === null || playerId === undefined) {
            throw new Error('Required parameter playerId was null or undefined when calling getTournamentPlayerEndpoint.');
        }

        let headers = this.defaultHeaders;

        // authentication (Keycloak) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<ModulesTournamentsApplicationTournamentPlayersTournamentPlayerResponse>('get',`${this.basePath}/tournaments/${encodeURIComponent(String(tournamentId))}/players/${encodeURIComponent(String(playerId))}`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Gets TournamentPlayerTypes for a TournamentPlayer.
     * Gets TournamentPlayerTypes for a TournamentPlayer.
     * @param tournamentId 
     * @param playerId 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getTournamentPlayerTypesByPlayerIdEndpoint(tournamentId: string, playerId: string, observe?: 'body', reportProgress?: boolean): Observable<Array<ModulesTournamentsApplicationTournamentPlayerTypesTournamentPlayerTypeResponse>>;
    public getTournamentPlayerTypesByPlayerIdEndpoint(tournamentId: string, playerId: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<ModulesTournamentsApplicationTournamentPlayerTypesTournamentPlayerTypeResponse>>>;
    public getTournamentPlayerTypesByPlayerIdEndpoint(tournamentId: string, playerId: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<ModulesTournamentsApplicationTournamentPlayerTypesTournamentPlayerTypeResponse>>>;
    public getTournamentPlayerTypesByPlayerIdEndpoint(tournamentId: string, playerId: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (tournamentId === null || tournamentId === undefined) {
            throw new Error('Required parameter tournamentId was null or undefined when calling getTournamentPlayerTypesByPlayerIdEndpoint.');
        }

        if (playerId === null || playerId === undefined) {
            throw new Error('Required parameter playerId was null or undefined when calling getTournamentPlayerTypesByPlayerIdEndpoint.');
        }

        let headers = this.defaultHeaders;

        // authentication (Keycloak) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<Array<ModulesTournamentsApplicationTournamentPlayerTypesTournamentPlayerTypeResponse>>('get',`${this.basePath}/tournaments/${encodeURIComponent(String(tournamentId))}/players/${encodeURIComponent(String(playerId))}/types`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Gets TournamentPlayerTypes.
     * Gets TournamentPlayerTypes for a Tournament.
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getTournamentPlayerTypesEndpoint(observe?: 'body', reportProgress?: boolean): Observable<Array<ModulesTournamentsApplicationTournamentPlayerTypesTournamentPlayerTypeResponse>>;
    public getTournamentPlayerTypesEndpoint(observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<ModulesTournamentsApplicationTournamentPlayerTypesTournamentPlayerTypeResponse>>>;
    public getTournamentPlayerTypesEndpoint(observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<ModulesTournamentsApplicationTournamentPlayerTypesTournamentPlayerTypeResponse>>>;
    public getTournamentPlayerTypesEndpoint(observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        let headers = this.defaultHeaders;

        // authentication (Keycloak) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<Array<ModulesTournamentsApplicationTournamentPlayerTypesTournamentPlayerTypeResponse>>('get',`${this.basePath}/tournaments/playerTypes`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Gets TournamentPlayers.
     * Gets TournamentPlayers by the Tournament identifier.
     * @param tournamentId 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getTournamentPlayersEndpoint(tournamentId: string, observe?: 'body', reportProgress?: boolean): Observable<Array<ModulesTournamentsApplicationTournamentPlayersTournamentPlayerResponse>>;
    public getTournamentPlayersEndpoint(tournamentId: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<ModulesTournamentsApplicationTournamentPlayersTournamentPlayerResponse>>>;
    public getTournamentPlayersEndpoint(tournamentId: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<ModulesTournamentsApplicationTournamentPlayersTournamentPlayerResponse>>>;
    public getTournamentPlayersEndpoint(tournamentId: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (tournamentId === null || tournamentId === undefined) {
            throw new Error('Required parameter tournamentId was null or undefined when calling getTournamentPlayersEndpoint.');
        }

        let headers = this.defaultHeaders;

        // authentication (Keycloak) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<Array<ModulesTournamentsApplicationTournamentPlayersTournamentPlayerResponse>>('get',`${this.basePath}/tournaments/${encodeURIComponent(String(tournamentId))}/players`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Gets a list of TournamentScoringTypes.
     * Retrieves all available TournamentScoringTypes.
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getTournamentScoringTypesEndpoint(observe?: 'body', reportProgress?: boolean): Observable<Array<ModulesTournamentsApplicationTournamentScoringTypesTournamentScoringTypeResponse>>;
    public getTournamentScoringTypesEndpoint(observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<ModulesTournamentsApplicationTournamentScoringTypesTournamentScoringTypeResponse>>>;
    public getTournamentScoringTypesEndpoint(observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<ModulesTournamentsApplicationTournamentScoringTypesTournamentScoringTypeResponse>>>;
    public getTournamentScoringTypesEndpoint(observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        let headers = this.defaultHeaders;

        // authentication (Keycloak) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<Array<ModulesTournamentsApplicationTournamentScoringTypesTournamentScoringTypeResponse>>('get',`${this.basePath}/tournaments/scoringTypes`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Gets a TournamentTeam.
     * Gets a TournamentTeam using the Tournament and Team identifiers.
     * @param tournamentId 
     * @param teamId 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getTournamentTeamEndpoint(tournamentId: string, teamId: string, observe?: 'body', reportProgress?: boolean): Observable<ModulesTournamentsApplicationTournamentTeamsTournamentTeamResponse>;
    public getTournamentTeamEndpoint(tournamentId: string, teamId: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<ModulesTournamentsApplicationTournamentTeamsTournamentTeamResponse>>;
    public getTournamentTeamEndpoint(tournamentId: string, teamId: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<ModulesTournamentsApplicationTournamentTeamsTournamentTeamResponse>>;
    public getTournamentTeamEndpoint(tournamentId: string, teamId: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (tournamentId === null || tournamentId === undefined) {
            throw new Error('Required parameter tournamentId was null or undefined when calling getTournamentTeamEndpoint.');
        }

        if (teamId === null || teamId === undefined) {
            throw new Error('Required parameter teamId was null or undefined when calling getTournamentTeamEndpoint.');
        }

        let headers = this.defaultHeaders;

        // authentication (Keycloak) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<ModulesTournamentsApplicationTournamentTeamsTournamentTeamResponse>('get',`${this.basePath}/tournaments/${encodeURIComponent(String(tournamentId))}/teams/${encodeURIComponent(String(teamId))}`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Gets a TournamentTeamPlayer (a Player on a Tournament Team).
     * Gets a TournamentTeamPlayer using the Tournament, Team and Player identifiers.
     * @param tournamentId 
     * @param teamId 
     * @param playerId 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getTournamentTeamPlayerEndpoint(tournamentId: string, teamId: string, playerId: string, observe?: 'body', reportProgress?: boolean): Observable<ModulesTournamentsApplicationTournamentTeamPlayersTournamentTeamPlayerResponse>;
    public getTournamentTeamPlayerEndpoint(tournamentId: string, teamId: string, playerId: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<ModulesTournamentsApplicationTournamentTeamPlayersTournamentTeamPlayerResponse>>;
    public getTournamentTeamPlayerEndpoint(tournamentId: string, teamId: string, playerId: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<ModulesTournamentsApplicationTournamentTeamPlayersTournamentTeamPlayerResponse>>;
    public getTournamentTeamPlayerEndpoint(tournamentId: string, teamId: string, playerId: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (tournamentId === null || tournamentId === undefined) {
            throw new Error('Required parameter tournamentId was null or undefined when calling getTournamentTeamPlayerEndpoint.');
        }

        if (teamId === null || teamId === undefined) {
            throw new Error('Required parameter teamId was null or undefined when calling getTournamentTeamPlayerEndpoint.');
        }

        if (playerId === null || playerId === undefined) {
            throw new Error('Required parameter playerId was null or undefined when calling getTournamentTeamPlayerEndpoint.');
        }

        let headers = this.defaultHeaders;

        // authentication (Keycloak) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<ModulesTournamentsApplicationTournamentTeamPlayersTournamentTeamPlayerResponse>('get',`${this.basePath}/tournaments/${encodeURIComponent(String(tournamentId))}/teams/${encodeURIComponent(String(teamId))}/players/${encodeURIComponent(String(playerId))}`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Gets TournamentTeams.
     * Gets TournamentTeams by the Tournament identifier.
     * @param tournamentId 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getTournamentTeamsByTournamentIdEndpoint(tournamentId: string, observe?: 'body', reportProgress?: boolean): Observable<Array<ModulesTournamentsApplicationTournamentTeamsTournamentTeamResponse>>;
    public getTournamentTeamsByTournamentIdEndpoint(tournamentId: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<ModulesTournamentsApplicationTournamentTeamsTournamentTeamResponse>>>;
    public getTournamentTeamsByTournamentIdEndpoint(tournamentId: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<ModulesTournamentsApplicationTournamentTeamsTournamentTeamResponse>>>;
    public getTournamentTeamsByTournamentIdEndpoint(tournamentId: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (tournamentId === null || tournamentId === undefined) {
            throw new Error('Required parameter tournamentId was null or undefined when calling getTournamentTeamsByTournamentIdEndpoint.');
        }

        let headers = this.defaultHeaders;

        // authentication (Keycloak) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<Array<ModulesTournamentsApplicationTournamentTeamsTournamentTeamResponse>>('get',`${this.basePath}/tournaments/${encodeURIComponent(String(tournamentId))}/teams`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Gets one or more Tournaments.
     * Gets one or more Tournaments by querystring parameters.
     * @param tourId 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getTournamentsEndpoint(tourId?: string, observe?: 'body', reportProgress?: boolean): Observable<Array<ModulesTournamentsApplicationTournamentsTournamentResponse>>;
    public getTournamentsEndpoint(tourId?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<ModulesTournamentsApplicationTournamentsTournamentResponse>>>;
    public getTournamentsEndpoint(tourId?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<ModulesTournamentsApplicationTournamentsTournamentResponse>>>;
    public getTournamentsEndpoint(tourId?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {


        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (tourId !== undefined && tourId !== null) {
            queryParameters = queryParameters.set('tourId', <any>tourId);
        }

        let headers = this.defaultHeaders;

        // authentication (Keycloak) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<Array<ModulesTournamentsApplicationTournamentsTournamentResponse>>('get',`${this.basePath}/tournaments`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Creates a Tournament.
     * Creates a Tournament based on the CreateTournamentRequest request.
     * @param body 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public tournamentsPost(body?: ModulesTournamentsEndpointsContractsTournamentsCreateTournamentRequest, observe?: 'body', reportProgress?: boolean): Observable<string>;
    public tournamentsPost(body?: ModulesTournamentsEndpointsContractsTournamentsCreateTournamentRequest, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<string>>;
    public tournamentsPost(body?: ModulesTournamentsEndpointsContractsTournamentsCreateTournamentRequest, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<string>>;
    public tournamentsPost(body?: ModulesTournamentsEndpointsContractsTournamentsCreateTournamentRequest, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {


        let headers = this.defaultHeaders;

        // authentication (Keycloak) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json',
            'text/json',
            'application/_*+json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.request<string>('post',`${this.basePath}/tournaments`,
            {
                body: body,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Closes a Tournament.
     * Closes a Tournament, marking it as official. All rounds must be official before the tournament can be closed.
     * @param tournamentId 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public tournamentsTournamentIdClosePost(tournamentId: string, observe?: 'body', reportProgress?: boolean): Observable<ModulesTournamentsApplicationTournamentsCloseTournamentCloseTournamentResponse>;
    public tournamentsTournamentIdClosePost(tournamentId: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<ModulesTournamentsApplicationTournamentsCloseTournamentCloseTournamentResponse>>;
    public tournamentsTournamentIdClosePost(tournamentId: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<ModulesTournamentsApplicationTournamentsCloseTournamentCloseTournamentResponse>>;
    public tournamentsTournamentIdClosePost(tournamentId: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (tournamentId === null || tournamentId === undefined) {
            throw new Error('Required parameter tournamentId was null or undefined when calling tournamentsTournamentIdClosePost.');
        }

        let headers = this.defaultHeaders;

        // authentication (Keycloak) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<ModulesTournamentsApplicationTournamentsCloseTournamentCloseTournamentResponse>('post',`${this.basePath}/tournaments/${encodeURIComponent(String(tournamentId))}/close`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Removes a TournamentCourse.
     * Removes a TournamentCourse using the Tournament and Course identifiers.
     * @param tournamentId 
     * @param courseId 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public tournamentsTournamentIdCoursesCourseIdDelete(tournamentId: string, courseId: string, observe?: 'body', reportProgress?: boolean): Observable<any>;
    public tournamentsTournamentIdCoursesCourseIdDelete(tournamentId: string, courseId: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<any>>;
    public tournamentsTournamentIdCoursesCourseIdDelete(tournamentId: string, courseId: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<any>>;
    public tournamentsTournamentIdCoursesCourseIdDelete(tournamentId: string, courseId: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (tournamentId === null || tournamentId === undefined) {
            throw new Error('Required parameter tournamentId was null or undefined when calling tournamentsTournamentIdCoursesCourseIdDelete.');
        }

        if (courseId === null || courseId === undefined) {
            throw new Error('Required parameter courseId was null or undefined when calling tournamentsTournamentIdCoursesCourseIdDelete.');
        }

        let headers = this.defaultHeaders;

        // authentication (Keycloak) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<any>('delete',`${this.basePath}/tournaments/${encodeURIComponent(String(tournamentId))}/courses/${encodeURIComponent(String(courseId))}`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Creates a TournamentCourse.
     * Creates a TournamentCourse based on the Tournament and Course identifiers.
     * @param tournamentId 
     * @param courseId 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public tournamentsTournamentIdCoursesCourseIdPost(tournamentId: string, courseId: string, observe?: 'body', reportProgress?: boolean): Observable<number>;
    public tournamentsTournamentIdCoursesCourseIdPost(tournamentId: string, courseId: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<number>>;
    public tournamentsTournamentIdCoursesCourseIdPost(tournamentId: string, courseId: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<number>>;
    public tournamentsTournamentIdCoursesCourseIdPost(tournamentId: string, courseId: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (tournamentId === null || tournamentId === undefined) {
            throw new Error('Required parameter tournamentId was null or undefined when calling tournamentsTournamentIdCoursesCourseIdPost.');
        }

        if (courseId === null || courseId === undefined) {
            throw new Error('Required parameter courseId was null or undefined when calling tournamentsTournamentIdCoursesCourseIdPost.');
        }

        let headers = this.defaultHeaders;

        // authentication (Keycloak) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<number>('post',`${this.basePath}/tournaments/${encodeURIComponent(String(tournamentId))}/courses/${encodeURIComponent(String(courseId))}`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Removes a Block.
     * Removes a Block based on the RemoveBlockRequest request.
     * @param tournamentId 
     * @param courseId 
     * @param roundId 
     * @param blockId 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public tournamentsTournamentIdCoursesCourseIdRoundsRoundIdBlocksBlockIdDelete(tournamentId: string, courseId: string, roundId: string, blockId: string, observe?: 'body', reportProgress?: boolean): Observable<any>;
    public tournamentsTournamentIdCoursesCourseIdRoundsRoundIdBlocksBlockIdDelete(tournamentId: string, courseId: string, roundId: string, blockId: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<any>>;
    public tournamentsTournamentIdCoursesCourseIdRoundsRoundIdBlocksBlockIdDelete(tournamentId: string, courseId: string, roundId: string, blockId: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<any>>;
    public tournamentsTournamentIdCoursesCourseIdRoundsRoundIdBlocksBlockIdDelete(tournamentId: string, courseId: string, roundId: string, blockId: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (tournamentId === null || tournamentId === undefined) {
            throw new Error('Required parameter tournamentId was null or undefined when calling tournamentsTournamentIdCoursesCourseIdRoundsRoundIdBlocksBlockIdDelete.');
        }

        if (courseId === null || courseId === undefined) {
            throw new Error('Required parameter courseId was null or undefined when calling tournamentsTournamentIdCoursesCourseIdRoundsRoundIdBlocksBlockIdDelete.');
        }

        if (roundId === null || roundId === undefined) {
            throw new Error('Required parameter roundId was null or undefined when calling tournamentsTournamentIdCoursesCourseIdRoundsRoundIdBlocksBlockIdDelete.');
        }

        if (blockId === null || blockId === undefined) {
            throw new Error('Required parameter blockId was null or undefined when calling tournamentsTournamentIdCoursesCourseIdRoundsRoundIdBlocksBlockIdDelete.');
        }

        let headers = this.defaultHeaders;

        // authentication (Keycloak) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<any>('delete',`${this.basePath}/tournaments/${encodeURIComponent(String(tournamentId))}/courses/${encodeURIComponent(String(courseId))}/rounds/${encodeURIComponent(String(roundId))}/blocks/${encodeURIComponent(String(blockId))}`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Creates a Block.
     * Creates a Block based on the CreateBlockRequest request.
     * @param tournamentId 
     * @param courseId 
     * @param roundId 
     * @param body 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public tournamentsTournamentIdCoursesCourseIdRoundsRoundIdBlocksPost(tournamentId: string, courseId: string, roundId: string, body?: ModulesGroupsEndpointsContractsBlocksCreateBlockRequestModel, observe?: 'body', reportProgress?: boolean): Observable<any>;
    public tournamentsTournamentIdCoursesCourseIdRoundsRoundIdBlocksPost(tournamentId: string, courseId: string, roundId: string, body?: ModulesGroupsEndpointsContractsBlocksCreateBlockRequestModel, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<any>>;
    public tournamentsTournamentIdCoursesCourseIdRoundsRoundIdBlocksPost(tournamentId: string, courseId: string, roundId: string, body?: ModulesGroupsEndpointsContractsBlocksCreateBlockRequestModel, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<any>>;
    public tournamentsTournamentIdCoursesCourseIdRoundsRoundIdBlocksPost(tournamentId: string, courseId: string, roundId: string, body?: ModulesGroupsEndpointsContractsBlocksCreateBlockRequestModel, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (tournamentId === null || tournamentId === undefined) {
            throw new Error('Required parameter tournamentId was null or undefined when calling tournamentsTournamentIdCoursesCourseIdRoundsRoundIdBlocksPost.');
        }

        if (courseId === null || courseId === undefined) {
            throw new Error('Required parameter courseId was null or undefined when calling tournamentsTournamentIdCoursesCourseIdRoundsRoundIdBlocksPost.');
        }

        if (roundId === null || roundId === undefined) {
            throw new Error('Required parameter roundId was null or undefined when calling tournamentsTournamentIdCoursesCourseIdRoundsRoundIdBlocksPost.');
        }


        let headers = this.defaultHeaders;

        // authentication (Keycloak) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json',
            'text/json',
            'application/_*+json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.request<any>('post',`${this.basePath}/tournaments/${encodeURIComponent(String(tournamentId))}/courses/${encodeURIComponent(String(courseId))}/rounds/${encodeURIComponent(String(roundId))}/blocks`,
            {
                body: body,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Creates a RoundTournamentCourse.
     * Creates a RoundTournamentCourse based on Tournament, Course and Round identifiers.
     * @param tournamentId 
     * @param courseId 
     * @param roundId 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public tournamentsTournamentIdCoursesCourseIdRoundsRoundIdPost(tournamentId: string, courseId: string, roundId: string, observe?: 'body', reportProgress?: boolean): Observable<number>;
    public tournamentsTournamentIdCoursesCourseIdRoundsRoundIdPost(tournamentId: string, courseId: string, roundId: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<number>>;
    public tournamentsTournamentIdCoursesCourseIdRoundsRoundIdPost(tournamentId: string, courseId: string, roundId: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<number>>;
    public tournamentsTournamentIdCoursesCourseIdRoundsRoundIdPost(tournamentId: string, courseId: string, roundId: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (tournamentId === null || tournamentId === undefined) {
            throw new Error('Required parameter tournamentId was null or undefined when calling tournamentsTournamentIdCoursesCourseIdRoundsRoundIdPost.');
        }

        if (courseId === null || courseId === undefined) {
            throw new Error('Required parameter courseId was null or undefined when calling tournamentsTournamentIdCoursesCourseIdRoundsRoundIdPost.');
        }

        if (roundId === null || roundId === undefined) {
            throw new Error('Required parameter roundId was null or undefined when calling tournamentsTournamentIdCoursesCourseIdRoundsRoundIdPost.');
        }

        let headers = this.defaultHeaders;

        // authentication (Keycloak) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<number>('post',`${this.basePath}/tournaments/${encodeURIComponent(String(tournamentId))}/courses/${encodeURIComponent(String(courseId))}/rounds/${encodeURIComponent(String(roundId))}`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Removes a Tournament.
     * Removes a Tournament using the Tournament identifier.
     * @param tournamentId 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public tournamentsTournamentIdDelete(tournamentId: string, observe?: 'body', reportProgress?: boolean): Observable<any>;
    public tournamentsTournamentIdDelete(tournamentId: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<any>>;
    public tournamentsTournamentIdDelete(tournamentId: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<any>>;
    public tournamentsTournamentIdDelete(tournamentId: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (tournamentId === null || tournamentId === undefined) {
            throw new Error('Required parameter tournamentId was null or undefined when calling tournamentsTournamentIdDelete.');
        }

        let headers = this.defaultHeaders;

        // authentication (Keycloak) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<any>('delete',`${this.basePath}/tournaments/${encodeURIComponent(String(tournamentId))}`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Marks a Tournament Active.
     * Marks a Tournament Active based on the TournamentId.
     * @param tournamentId 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public tournamentsTournamentIdMarkActivePost(tournamentId: string, observe?: 'body', reportProgress?: boolean): Observable<string>;
    public tournamentsTournamentIdMarkActivePost(tournamentId: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<string>>;
    public tournamentsTournamentIdMarkActivePost(tournamentId: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<string>>;
    public tournamentsTournamentIdMarkActivePost(tournamentId: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (tournamentId === null || tournamentId === undefined) {
            throw new Error('Required parameter tournamentId was null or undefined when calling tournamentsTournamentIdMarkActivePost.');
        }

        let headers = this.defaultHeaders;

        // authentication (Keycloak) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<string>('post',`${this.basePath}/tournaments/${encodeURIComponent(String(tournamentId))}/mark-active`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Assigns player brackets based on rankings
     * Assigns player types (A, B, C, ALT) based on their ranks and the specified bracket sizes. Players are sorted by A/B rank, then assigned types sequentially. Players beyond MaxFieldSize become alternates.
     * @param tournamentId 
     * @param body 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public tournamentsTournamentIdPlayersAssignBracketsPost(tournamentId: string, body?: ModulesTournamentsEndpointsContractsTournamentPlayersAssignPlayerBracketsRequestModel, observe?: 'body', reportProgress?: boolean): Observable<any>;
    public tournamentsTournamentIdPlayersAssignBracketsPost(tournamentId: string, body?: ModulesTournamentsEndpointsContractsTournamentPlayersAssignPlayerBracketsRequestModel, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<any>>;
    public tournamentsTournamentIdPlayersAssignBracketsPost(tournamentId: string, body?: ModulesTournamentsEndpointsContractsTournamentPlayersAssignPlayerBracketsRequestModel, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<any>>;
    public tournamentsTournamentIdPlayersAssignBracketsPost(tournamentId: string, body?: ModulesTournamentsEndpointsContractsTournamentPlayersAssignPlayerBracketsRequestModel, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (tournamentId === null || tournamentId === undefined) {
            throw new Error('Required parameter tournamentId was null or undefined when calling tournamentsTournamentIdPlayersAssignBracketsPost.');
        }


        let headers = this.defaultHeaders;

        // authentication (Keycloak) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json',
            'text/json',
            'application/_*+json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.request<any>('post',`${this.basePath}/tournaments/${encodeURIComponent(String(tournamentId))}/players/assign-brackets`,
            {
                body: body,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Removes a TournamentPlayer.
     * Removes a TournamentPlayer using the Tournament and Player identifiers.
     * @param tournamentId 
     * @param playerId 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public tournamentsTournamentIdPlayersPlayerIdDelete(tournamentId: string, playerId: string, observe?: 'body', reportProgress?: boolean): Observable<any>;
    public tournamentsTournamentIdPlayersPlayerIdDelete(tournamentId: string, playerId: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<any>>;
    public tournamentsTournamentIdPlayersPlayerIdDelete(tournamentId: string, playerId: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<any>>;
    public tournamentsTournamentIdPlayersPlayerIdDelete(tournamentId: string, playerId: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (tournamentId === null || tournamentId === undefined) {
            throw new Error('Required parameter tournamentId was null or undefined when calling tournamentsTournamentIdPlayersPlayerIdDelete.');
        }

        if (playerId === null || playerId === undefined) {
            throw new Error('Required parameter playerId was null or undefined when calling tournamentsTournamentIdPlayersPlayerIdDelete.');
        }

        let headers = this.defaultHeaders;

        // authentication (Keycloak) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<any>('delete',`${this.basePath}/tournaments/${encodeURIComponent(String(tournamentId))}/players/${encodeURIComponent(String(playerId))}`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Moves a field player to alternates.
     * Moves a field player to alternates by updating IsAlternate flag, round status, and optionally deleting scorecards if confirmed.
     * @param tournamentId 
     * @param playerId 
     * @param body 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public tournamentsTournamentIdPlayersPlayerIdMoveToAlternatesPost(tournamentId: string, playerId: string, body?: ModulesTournamentsEndpointsContractsTournamentPlayersMovePlayerToAlternatesRequestModel, observe?: 'body', reportProgress?: boolean): Observable<any>;
    public tournamentsTournamentIdPlayersPlayerIdMoveToAlternatesPost(tournamentId: string, playerId: string, body?: ModulesTournamentsEndpointsContractsTournamentPlayersMovePlayerToAlternatesRequestModel, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<any>>;
    public tournamentsTournamentIdPlayersPlayerIdMoveToAlternatesPost(tournamentId: string, playerId: string, body?: ModulesTournamentsEndpointsContractsTournamentPlayersMovePlayerToAlternatesRequestModel, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<any>>;
    public tournamentsTournamentIdPlayersPlayerIdMoveToAlternatesPost(tournamentId: string, playerId: string, body?: ModulesTournamentsEndpointsContractsTournamentPlayersMovePlayerToAlternatesRequestModel, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (tournamentId === null || tournamentId === undefined) {
            throw new Error('Required parameter tournamentId was null or undefined when calling tournamentsTournamentIdPlayersPlayerIdMoveToAlternatesPost.');
        }

        if (playerId === null || playerId === undefined) {
            throw new Error('Required parameter playerId was null or undefined when calling tournamentsTournamentIdPlayersPlayerIdMoveToAlternatesPost.');
        }


        let headers = this.defaultHeaders;

        // authentication (Keycloak) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json',
            'text/json',
            'application/_*+json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.request<any>('post',`${this.basePath}/tournaments/${encodeURIComponent(String(tournamentId))}/players/${encodeURIComponent(String(playerId))}/move-to-alternates`,
            {
                body: body,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Moves an alternate player to the main field.
     * Moves an alternate player to the main field by updating IsAlternate flag and round status.
     * @param tournamentId 
     * @param playerId 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public tournamentsTournamentIdPlayersPlayerIdMoveToFieldPost(tournamentId: string, playerId: string, observe?: 'body', reportProgress?: boolean): Observable<any>;
    public tournamentsTournamentIdPlayersPlayerIdMoveToFieldPost(tournamentId: string, playerId: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<any>>;
    public tournamentsTournamentIdPlayersPlayerIdMoveToFieldPost(tournamentId: string, playerId: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<any>>;
    public tournamentsTournamentIdPlayersPlayerIdMoveToFieldPost(tournamentId: string, playerId: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (tournamentId === null || tournamentId === undefined) {
            throw new Error('Required parameter tournamentId was null or undefined when calling tournamentsTournamentIdPlayersPlayerIdMoveToFieldPost.');
        }

        if (playerId === null || playerId === undefined) {
            throw new Error('Required parameter playerId was null or undefined when calling tournamentsTournamentIdPlayersPlayerIdMoveToFieldPost.');
        }

        let headers = this.defaultHeaders;

        // authentication (Keycloak) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<any>('post',`${this.basePath}/tournaments/${encodeURIComponent(String(tournamentId))}/players/${encodeURIComponent(String(playerId))}/move-to-field`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Creates a TournamentPlayer.
     * Creates a TournamentPlayer based on the Tournament and Player identifiers and the CreateTournamentPlayerRequest request.
     * @param tournamentId 
     * @param playerId 
     * @param body 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public tournamentsTournamentIdPlayersPlayerIdPost(tournamentId: string, playerId: string, body?: ModulesTournamentsEndpointsContractsTournamentPlayersCreateTournamentPlayerRequestModel, observe?: 'body', reportProgress?: boolean): Observable<number>;
    public tournamentsTournamentIdPlayersPlayerIdPost(tournamentId: string, playerId: string, body?: ModulesTournamentsEndpointsContractsTournamentPlayersCreateTournamentPlayerRequestModel, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<number>>;
    public tournamentsTournamentIdPlayersPlayerIdPost(tournamentId: string, playerId: string, body?: ModulesTournamentsEndpointsContractsTournamentPlayersCreateTournamentPlayerRequestModel, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<number>>;
    public tournamentsTournamentIdPlayersPlayerIdPost(tournamentId: string, playerId: string, body?: ModulesTournamentsEndpointsContractsTournamentPlayersCreateTournamentPlayerRequestModel, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (tournamentId === null || tournamentId === undefined) {
            throw new Error('Required parameter tournamentId was null or undefined when calling tournamentsTournamentIdPlayersPlayerIdPost.');
        }

        if (playerId === null || playerId === undefined) {
            throw new Error('Required parameter playerId was null or undefined when calling tournamentsTournamentIdPlayersPlayerIdPost.');
        }


        let headers = this.defaultHeaders;

        // authentication (Keycloak) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json',
            'text/json',
            'application/_*+json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.request<number>('post',`${this.basePath}/tournaments/${encodeURIComponent(String(tournamentId))}/players/${encodeURIComponent(String(playerId))}`,
            {
                body: body,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Updates a TournamentPlayer.
     * Updates a TournamentPlayer based on the Tournament and Player identifiers and the UpdateTournamentPlayerRequest request.
     * @param tournamentId 
     * @param playerId 
     * @param body 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public tournamentsTournamentIdPlayersPlayerIdPut(tournamentId: string, playerId: string, body?: ModulesTournamentsEndpointsContractsTournamentPlayersUpdateTournamentPlayerRequestModel, observe?: 'body', reportProgress?: boolean): Observable<any>;
    public tournamentsTournamentIdPlayersPlayerIdPut(tournamentId: string, playerId: string, body?: ModulesTournamentsEndpointsContractsTournamentPlayersUpdateTournamentPlayerRequestModel, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<any>>;
    public tournamentsTournamentIdPlayersPlayerIdPut(tournamentId: string, playerId: string, body?: ModulesTournamentsEndpointsContractsTournamentPlayersUpdateTournamentPlayerRequestModel, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<any>>;
    public tournamentsTournamentIdPlayersPlayerIdPut(tournamentId: string, playerId: string, body?: ModulesTournamentsEndpointsContractsTournamentPlayersUpdateTournamentPlayerRequestModel, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (tournamentId === null || tournamentId === undefined) {
            throw new Error('Required parameter tournamentId was null or undefined when calling tournamentsTournamentIdPlayersPlayerIdPut.');
        }

        if (playerId === null || playerId === undefined) {
            throw new Error('Required parameter playerId was null or undefined when calling tournamentsTournamentIdPlayersPlayerIdPut.');
        }


        let headers = this.defaultHeaders;

        // authentication (Keycloak) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json',
            'text/json',
            'application/_*+json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.request<any>('put',`${this.basePath}/tournaments/${encodeURIComponent(String(tournamentId))}/players/${encodeURIComponent(String(playerId))}`,
            {
                body: body,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Swaps a field player with an alternate.
     * Swaps a field player with an alternate by transferring scorecards (if any) and swapping IsAlternate flags and round statuses.
     * @param tournamentId 
     * @param body 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public tournamentsTournamentIdPlayersSwapPost(tournamentId: string, body?: ModulesTournamentsEndpointsContractsTournamentPlayersSwapPlayerWithAlternateRequestModel, observe?: 'body', reportProgress?: boolean): Observable<any>;
    public tournamentsTournamentIdPlayersSwapPost(tournamentId: string, body?: ModulesTournamentsEndpointsContractsTournamentPlayersSwapPlayerWithAlternateRequestModel, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<any>>;
    public tournamentsTournamentIdPlayersSwapPost(tournamentId: string, body?: ModulesTournamentsEndpointsContractsTournamentPlayersSwapPlayerWithAlternateRequestModel, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<any>>;
    public tournamentsTournamentIdPlayersSwapPost(tournamentId: string, body?: ModulesTournamentsEndpointsContractsTournamentPlayersSwapPlayerWithAlternateRequestModel, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (tournamentId === null || tournamentId === undefined) {
            throw new Error('Required parameter tournamentId was null or undefined when calling tournamentsTournamentIdPlayersSwapPost.');
        }


        let headers = this.defaultHeaders;

        // authentication (Keycloak) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json',
            'text/json',
            'application/_*+json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.request<any>('post',`${this.basePath}/tournaments/${encodeURIComponent(String(tournamentId))}/players/swap`,
            {
                body: body,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Updates a Tournament.
     * Updates a Tournament based on the UpdateTournamentRequest request. Include ClassificationIds to update tournament classifications.
     * @param tournamentId 
     * @param body 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public tournamentsTournamentIdPut(tournamentId: string, body?: ModulesTournamentsEndpointsContractsTournamentsUpdateTournamentRequestModel, observe?: 'body', reportProgress?: boolean): Observable<any>;
    public tournamentsTournamentIdPut(tournamentId: string, body?: ModulesTournamentsEndpointsContractsTournamentsUpdateTournamentRequestModel, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<any>>;
    public tournamentsTournamentIdPut(tournamentId: string, body?: ModulesTournamentsEndpointsContractsTournamentsUpdateTournamentRequestModel, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<any>>;
    public tournamentsTournamentIdPut(tournamentId: string, body?: ModulesTournamentsEndpointsContractsTournamentsUpdateTournamentRequestModel, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (tournamentId === null || tournamentId === undefined) {
            throw new Error('Required parameter tournamentId was null or undefined when calling tournamentsTournamentIdPut.');
        }


        let headers = this.defaultHeaders;

        // authentication (Keycloak) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json',
            'text/json',
            'application/_*+json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.request<any>('put',`${this.basePath}/tournaments/${encodeURIComponent(String(tournamentId))}`,
            {
                body: body,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Creates a Round.
     * Creates a Round based on the Tournament identifier and CreateRoundRequest.
     * @param tournamentId 
     * @param body 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public tournamentsTournamentIdRoundsPost(tournamentId: string, body?: ModulesTournamentsEndpointsContractsRoundsCreateRoundRequestModel, observe?: 'body', reportProgress?: boolean): Observable<number>;
    public tournamentsTournamentIdRoundsPost(tournamentId: string, body?: ModulesTournamentsEndpointsContractsRoundsCreateRoundRequestModel, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<number>>;
    public tournamentsTournamentIdRoundsPost(tournamentId: string, body?: ModulesTournamentsEndpointsContractsRoundsCreateRoundRequestModel, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<number>>;
    public tournamentsTournamentIdRoundsPost(tournamentId: string, body?: ModulesTournamentsEndpointsContractsRoundsCreateRoundRequestModel, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (tournamentId === null || tournamentId === undefined) {
            throw new Error('Required parameter tournamentId was null or undefined when calling tournamentsTournamentIdRoundsPost.');
        }


        let headers = this.defaultHeaders;

        // authentication (Keycloak) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json',
            'text/json',
            'application/_*+json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.request<number>('post',`${this.basePath}/tournaments/${encodeURIComponent(String(tournamentId))}/rounds`,
            {
                body: body,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Closes a Round.
     * Closes a Round, marking it as official and preparing the next round (if applicable). If Force&#x3D;true, ignores unofficial scorecards.
     * @param tournamentId 
     * @param roundId 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public tournamentsTournamentIdRoundsRoundIdClosePost(tournamentId: string, roundId: string, observe?: 'body', reportProgress?: boolean): Observable<ModulesTournamentsApplicationRoundsCloseRoundCloseRoundResponse>;
    public tournamentsTournamentIdRoundsRoundIdClosePost(tournamentId: string, roundId: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<ModulesTournamentsApplicationRoundsCloseRoundCloseRoundResponse>>;
    public tournamentsTournamentIdRoundsRoundIdClosePost(tournamentId: string, roundId: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<ModulesTournamentsApplicationRoundsCloseRoundCloseRoundResponse>>;
    public tournamentsTournamentIdRoundsRoundIdClosePost(tournamentId: string, roundId: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (tournamentId === null || tournamentId === undefined) {
            throw new Error('Required parameter tournamentId was null or undefined when calling tournamentsTournamentIdRoundsRoundIdClosePost.');
        }

        if (roundId === null || roundId === undefined) {
            throw new Error('Required parameter roundId was null or undefined when calling tournamentsTournamentIdRoundsRoundIdClosePost.');
        }

        let headers = this.defaultHeaders;

        // authentication (Keycloak) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<ModulesTournamentsApplicationRoundsCloseRoundCloseRoundResponse>('post',`${this.basePath}/tournaments/${encodeURIComponent(String(tournamentId))}/rounds/${encodeURIComponent(String(roundId))}/close`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Removes a Round.
     * Removes a Round using the Tournament and Round identifiers.
     * @param tournamentId 
     * @param roundId 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public tournamentsTournamentIdRoundsRoundIdDelete(tournamentId: string, roundId: string, observe?: 'body', reportProgress?: boolean): Observable<any>;
    public tournamentsTournamentIdRoundsRoundIdDelete(tournamentId: string, roundId: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<any>>;
    public tournamentsTournamentIdRoundsRoundIdDelete(tournamentId: string, roundId: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<any>>;
    public tournamentsTournamentIdRoundsRoundIdDelete(tournamentId: string, roundId: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (tournamentId === null || tournamentId === undefined) {
            throw new Error('Required parameter tournamentId was null or undefined when calling tournamentsTournamentIdRoundsRoundIdDelete.');
        }

        if (roundId === null || roundId === undefined) {
            throw new Error('Required parameter roundId was null or undefined when calling tournamentsTournamentIdRoundsRoundIdDelete.');
        }

        let headers = this.defaultHeaders;

        // authentication (Keycloak) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<any>('delete',`${this.basePath}/tournaments/${encodeURIComponent(String(tournamentId))}/rounds/${encodeURIComponent(String(roundId))}`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Updates a Round.
     * Updates a Round based on the Tournament and Round identifiers and UpdateRoundRequest.
     * @param tournamentId 
     * @param roundId 
     * @param body 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public tournamentsTournamentIdRoundsRoundIdPut(tournamentId: string, roundId: string, body?: ModulesTournamentsEndpointsContractsRoundsUpdateRoundRequestModel, observe?: 'body', reportProgress?: boolean): Observable<any>;
    public tournamentsTournamentIdRoundsRoundIdPut(tournamentId: string, roundId: string, body?: ModulesTournamentsEndpointsContractsRoundsUpdateRoundRequestModel, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<any>>;
    public tournamentsTournamentIdRoundsRoundIdPut(tournamentId: string, roundId: string, body?: ModulesTournamentsEndpointsContractsRoundsUpdateRoundRequestModel, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<any>>;
    public tournamentsTournamentIdRoundsRoundIdPut(tournamentId: string, roundId: string, body?: ModulesTournamentsEndpointsContractsRoundsUpdateRoundRequestModel, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (tournamentId === null || tournamentId === undefined) {
            throw new Error('Required parameter tournamentId was null or undefined when calling tournamentsTournamentIdRoundsRoundIdPut.');
        }

        if (roundId === null || roundId === undefined) {
            throw new Error('Required parameter roundId was null or undefined when calling tournamentsTournamentIdRoundsRoundIdPut.');
        }


        let headers = this.defaultHeaders;

        // authentication (Keycloak) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json',
            'text/json',
            'application/_*+json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.request<any>('put',`${this.basePath}/tournaments/${encodeURIComponent(String(tournamentId))}/rounds/${encodeURIComponent(String(roundId))}`,
            {
                body: body,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Gets unofficial scorecards for a round.
     * Gets the count and list of unofficial scorecards for active/winning players in a round.
     * @param tournamentId 
     * @param roundId 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public tournamentsTournamentIdRoundsRoundIdUnofficialScorecardsGet(tournamentId: string, roundId: string, observe?: 'body', reportProgress?: boolean): Observable<ModulesTournamentsApplicationRoundsGetUnofficialScorecardsGetUnofficialScorecardsResponse>;
    public tournamentsTournamentIdRoundsRoundIdUnofficialScorecardsGet(tournamentId: string, roundId: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<ModulesTournamentsApplicationRoundsGetUnofficialScorecardsGetUnofficialScorecardsResponse>>;
    public tournamentsTournamentIdRoundsRoundIdUnofficialScorecardsGet(tournamentId: string, roundId: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<ModulesTournamentsApplicationRoundsGetUnofficialScorecardsGetUnofficialScorecardsResponse>>;
    public tournamentsTournamentIdRoundsRoundIdUnofficialScorecardsGet(tournamentId: string, roundId: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (tournamentId === null || tournamentId === undefined) {
            throw new Error('Required parameter tournamentId was null or undefined when calling tournamentsTournamentIdRoundsRoundIdUnofficialScorecardsGet.');
        }

        if (roundId === null || roundId === undefined) {
            throw new Error('Required parameter roundId was null or undefined when calling tournamentsTournamentIdRoundsRoundIdUnofficialScorecardsGet.');
        }

        let headers = this.defaultHeaders;

        // authentication (Keycloak) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<ModulesTournamentsApplicationRoundsGetUnofficialScorecardsGetUnofficialScorecardsResponse>('get',`${this.basePath}/tournaments/${encodeURIComponent(String(tournamentId))}/rounds/${encodeURIComponent(String(roundId))}/unofficial-scorecards`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Removes a TournamentTeam.
     * Removes a TournamentTeam using the Tournament and Team identifiers.
     * @param tournamentId 
     * @param teamId 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public tournamentsTournamentIdTeamsTeamIdDelete(tournamentId: string, teamId: string, observe?: 'body', reportProgress?: boolean): Observable<any>;
    public tournamentsTournamentIdTeamsTeamIdDelete(tournamentId: string, teamId: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<any>>;
    public tournamentsTournamentIdTeamsTeamIdDelete(tournamentId: string, teamId: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<any>>;
    public tournamentsTournamentIdTeamsTeamIdDelete(tournamentId: string, teamId: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (tournamentId === null || tournamentId === undefined) {
            throw new Error('Required parameter tournamentId was null or undefined when calling tournamentsTournamentIdTeamsTeamIdDelete.');
        }

        if (teamId === null || teamId === undefined) {
            throw new Error('Required parameter teamId was null or undefined when calling tournamentsTournamentIdTeamsTeamIdDelete.');
        }

        let headers = this.defaultHeaders;

        // authentication (Keycloak) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<any>('delete',`${this.basePath}/tournaments/${encodeURIComponent(String(tournamentId))}/teams/${encodeURIComponent(String(teamId))}`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Removes a TournamentTeamPlayer (removes a Player from a Tournament Team).
     * Removes a TournamentTeamPlayer using the Tournament and Player identifiers.
     * @param tournamentId 
     * @param teamId 
     * @param playerId 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public tournamentsTournamentIdTeamsTeamIdPlayersPlayerIdDelete(tournamentId: string, teamId: string, playerId: string, observe?: 'body', reportProgress?: boolean): Observable<any>;
    public tournamentsTournamentIdTeamsTeamIdPlayersPlayerIdDelete(tournamentId: string, teamId: string, playerId: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<any>>;
    public tournamentsTournamentIdTeamsTeamIdPlayersPlayerIdDelete(tournamentId: string, teamId: string, playerId: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<any>>;
    public tournamentsTournamentIdTeamsTeamIdPlayersPlayerIdDelete(tournamentId: string, teamId: string, playerId: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (tournamentId === null || tournamentId === undefined) {
            throw new Error('Required parameter tournamentId was null or undefined when calling tournamentsTournamentIdTeamsTeamIdPlayersPlayerIdDelete.');
        }

        if (teamId === null || teamId === undefined) {
            throw new Error('Required parameter teamId was null or undefined when calling tournamentsTournamentIdTeamsTeamIdPlayersPlayerIdDelete.');
        }

        if (playerId === null || playerId === undefined) {
            throw new Error('Required parameter playerId was null or undefined when calling tournamentsTournamentIdTeamsTeamIdPlayersPlayerIdDelete.');
        }

        let headers = this.defaultHeaders;

        // authentication (Keycloak) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<any>('delete',`${this.basePath}/tournaments/${encodeURIComponent(String(tournamentId))}/teams/${encodeURIComponent(String(teamId))}/players/${encodeURIComponent(String(playerId))}`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Creates a TournamentTeamPlayer (adds a Player to a  Tournament Team).
     * Adds a Player to a Team by creating a TournamentTeamPlayer based on the Tournament, Team and Player identifiers.
     * @param tournamentId 
     * @param teamId 
     * @param playerId 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public tournamentsTournamentIdTeamsTeamIdPlayersPlayerIdPost(tournamentId: string, teamId: string, playerId: string, observe?: 'body', reportProgress?: boolean): Observable<ModulesTournamentsEndpointsContractsTournamentTeamPlayersTournamentTeamPlayerRequest>;
    public tournamentsTournamentIdTeamsTeamIdPlayersPlayerIdPost(tournamentId: string, teamId: string, playerId: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<ModulesTournamentsEndpointsContractsTournamentTeamPlayersTournamentTeamPlayerRequest>>;
    public tournamentsTournamentIdTeamsTeamIdPlayersPlayerIdPost(tournamentId: string, teamId: string, playerId: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<ModulesTournamentsEndpointsContractsTournamentTeamPlayersTournamentTeamPlayerRequest>>;
    public tournamentsTournamentIdTeamsTeamIdPlayersPlayerIdPost(tournamentId: string, teamId: string, playerId: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (tournamentId === null || tournamentId === undefined) {
            throw new Error('Required parameter tournamentId was null or undefined when calling tournamentsTournamentIdTeamsTeamIdPlayersPlayerIdPost.');
        }

        if (teamId === null || teamId === undefined) {
            throw new Error('Required parameter teamId was null or undefined when calling tournamentsTournamentIdTeamsTeamIdPlayersPlayerIdPost.');
        }

        if (playerId === null || playerId === undefined) {
            throw new Error('Required parameter playerId was null or undefined when calling tournamentsTournamentIdTeamsTeamIdPlayersPlayerIdPost.');
        }

        let headers = this.defaultHeaders;

        // authentication (Keycloak) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<ModulesTournamentsEndpointsContractsTournamentTeamPlayersTournamentTeamPlayerRequest>('post',`${this.basePath}/tournaments/${encodeURIComponent(String(tournamentId))}/teams/${encodeURIComponent(String(teamId))}/players/${encodeURIComponent(String(playerId))}`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Creates a TournamentTeam.
     * Creates a TournamentTeam based on the Tournament and Team identifiers and the CreateTournamentTeamRequest request.
     * @param tournamentId 
     * @param teamId 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public tournamentsTournamentIdTeamsTeamIdPost(tournamentId: string, teamId: string, observe?: 'body', reportProgress?: boolean): Observable<number>;
    public tournamentsTournamentIdTeamsTeamIdPost(tournamentId: string, teamId: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<number>>;
    public tournamentsTournamentIdTeamsTeamIdPost(tournamentId: string, teamId: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<number>>;
    public tournamentsTournamentIdTeamsTeamIdPost(tournamentId: string, teamId: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (tournamentId === null || tournamentId === undefined) {
            throw new Error('Required parameter tournamentId was null or undefined when calling tournamentsTournamentIdTeamsTeamIdPost.');
        }

        if (teamId === null || teamId === undefined) {
            throw new Error('Required parameter teamId was null or undefined when calling tournamentsTournamentIdTeamsTeamIdPost.');
        }

        let headers = this.defaultHeaders;

        // authentication (Keycloak) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<number>('post',`${this.basePath}/tournaments/${encodeURIComponent(String(tournamentId))}/teams/${encodeURIComponent(String(teamId))}`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

}
